import React, { Component } from "react";
import WorkItem from "./WorkItem";
import Image from "../../assets/img/work/png/oee.png";

class OEE extends Component {
  componentDidMount() {
    this.item.componentDidMount();
  }

  enterTransition = time => {
    this.item.enterTransition(time);
  };

  exitTransition = time => {
    this.item.exitTransition(time);
  };

  render = () => {
    return (
      <WorkItem
        ref={item => (this.item = item)}
        title="OEE"
        description={`OEE (Overall Equipment Effectiveness) application for automated manufactoring lines. Real time SPA
        (single
        page application) where data comes from sensors to mathematical model and provides a real time
        statistics
        of product line. The greatest challenge was to create high performance mathematical model and advanced
        reporting. Our part: requirements analysis, mathematical model, backend and frontend development,
        automated testing.`}
        image={Image}
        iconList={["react", "redux", "php", "mysql"]}
      />
    );
  };
}

export default OEE;



// WEBPACK FOOTER //
// ./src/components/Work/OEE.js